module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0130.jpg?v=acda3a27";